import React, { useState, useEffect } from "react";
import "../blog.css";
import { Button, Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import NavBar from "../../navbar/navbar";
import Footer from "../../footer/footer";
import axios from "axios";
import {
  baseUrl,
} from "../../../components/network/constants/Constants.js";

function MoreBlog() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [blog, setBlog] = useState([]);

  useEffect(() => {
    fetchBlog();
  }, []);

  const fetchBlog = () => {
    setLoading(true);
    
    axios
      .get(baseUrl + "web/blog-list/")
      .then((response) => {
        setLoading(false);

        if (response.data && Array.isArray(response.data.results)) {
          setBlog(response.data.results);
        } else {
          console.error("Unexpected data format:", response.data);
          setBlog([]);
        }
      })
      .catch((error) => {
        setLoading(false); 
        console.error("Error fetching blog data:", error);
      });
  };

  function HandleBlogNavigation(id) {
    const blogItem = blog.find(item => item.id === id);
    navigate(`/blogpage/${id}`, { state: blogItem });
  }

  return (
    <section id="blogpage">
      <NavBar />
      <div className="main-heading blog-mainhead">Blog</div>
      <Container>
        {loading ? (
          <div className="text-center py-5">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : blog.length > 0 ? (
          <div className="blog-row">
            <Row>
              {blog.map((blogItem, index) => (
                <Col
                  lg={6}
                  key={blogItem.id}
                  onClick={() => HandleBlogNavigation(blogItem.id)}
                  eventKey={index.toString()}
                >
                  <div className="blog-col">
                    <div className="blog-data">
                      <div className="blog-image">
                        <img
                          src={blogItem.blog_image}
                          className="blog-img"
                          alt="blog"
                        />
                      </div>
                      <div className="blog-person">
                        <div className="photo">
                          <img
                            src={blogItem.blog_author_image}
                            alt="blogger"
                            className="blogger"
                          />
                        </div>
                        <div className="bloger-name ms-3">
                          {blogItem.blog_author}
                        </div>
                      </div>
                    </div>
                    <div className="date">{blogItem.blog_date}</div>
                    <div className="underline"></div>
                    
                    {/* Render HTML title properly */}
                    <div 
                      className="blog-head"
                      dangerouslySetInnerHTML={{ __html: blogItem.blog_title }}
                    />
                    
                    {/* Render HTML body properly */}
                    <div
                      className="blog-content"
                      dangerouslySetInnerHTML={{
                        __html:
                          blogItem.blog_body.length > 350
                            ? blogItem.blog_body.slice(0, 350) + "..."
                            : blogItem.blog_body,
                      }}
                    />

                    <div className="blog-btn">
                      <Button
                        className="blog-button"
                        onClick={() => HandleBlogNavigation(blogItem.id)}
                      >
                        Read more
                      </Button>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        ) : (
          <p className="text-center py-5">No Blogs to display</p>
        )}
      </Container>
      <Footer />
    </section>
  );
}

export default MoreBlog;